import { styled } from '@/shared/ui';

export const StyledOl = styled('ol')(({ theme }) => ({
  margin: '0px',
  paddingLeft: '20px',
  color: theme.palette.custom.black[80],
}));

export const StyledLi = styled('li')(() => ({
  marginBottom: '20px',
}));
